// extracted by mini-css-extract-plugin
export default {"Root":"ChambersModal_Root__Vr4sz","RootTitle":"ChambersModal_RootTitle__+z-yS","EditButton":"ChambersModal_EditButton__NoKRn","Chambers":"ChambersModal_Chambers__V-Kj5"};